module.exports = __webpack_public_path__ + "static/media/Youtube-Fill.0fcb490a.svg";